/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon24Solid = forwardRef('XCircleIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM9.049 7.635a1 1 0 0 0-1.414 1.414L10.585 12l-2.95 2.951a1 1 0 1 0 1.414 1.414L12 13.415l2.951 2.95a1 1 0 0 0 1.414-1.414L13.415 12l2.95-2.951a1 1 0 0 0-1.414-1.414L12 10.585l-2.951-2.95Z" })));
});
